import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import * as data from '../../Lokesh_Profile.json'
const propTypes = {
  ...SectionProps.types
}
const info = data.info
const defaultProps = {
  ...SectionProps.defaults
}
// const info = [{
//     "name":'LOKESH KUMAR',
//     "tagline":"A Full Stack Software Engineer From India"
// }]

const Intro = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );



  return (
    <div className="container-sm intro" style={{height:'100vh'}}>
        <div className={innerClasses}>
          <div className="row slider-text align-items-center text-center justify-content-center">
            <h1 className="mt-0 mb-16 reveal-from-bottom"  data-reveal-delay="200">
              <p style={{fontSize:20,fontWeight:300, marginBottom:'0px',color:'#9CA9B3', letterSpacing:'5px'}}>HELLO! I'M</p>
               <span style={{letterSpacing:'10px',color:'white'}} className="text-color-primary">{info[0].name}</span>
            </h1>
            <div className="container-xs">
              <p style={{color:'white'}} className="mb-32 reveal-from-bottom" data-reveal-delay="400">
                {info[0].tagline}
              </p>
            </div>
          </div>
</div>
</div>
  );
}

export default Intro;